import { render } from "./MapArrayLegendComponent.vue?vue&type=template&id=006dd67b&scoped=true"
import script from "./MapArrayLegendComponent.vue?vue&type=script&lang=js"
export * from "./MapArrayLegendComponent.vue?vue&type=script&lang=js"

import "./MapArrayLegendComponent.vue?vue&type=style&index=0&id=006dd67b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006dd67b"]])

export default __exports__